/* eslint-disable no-unused-vars */
import { Mapper } from 'common/infrastructure/mapper';
import { OrganizationEntity } from './redux';
import { Organization as OrganizationDto } from 'api-client';

type OrganizationPersisted = Record<string, string | number | null>;

const fromDTO = (organization: OrganizationDto): OrganizationEntity => ({
  id: organization.id,
  tenantId: organization.tenantId,
  tp2OrganizationId: organization.tp2OrganizationId,
  center: organization.center,
  name: organization.name,
  boundingBox: organization.boundingBox,
});

const toPersistence = (organization: OrganizationEntity): OrganizationPersisted => ({
  id: organization.id,
  name: organization.name,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromPersistence = (data: any): OrganizationEntity => ({
  id: data.id,
  name: data.name,
});

const notImplemented = () => {
  throw new Error('Not implemented');
};

export const OrganizationMapper: Mapper<OrganizationEntity, OrganizationDto> = {
  toDTO: notImplemented,
  fromDTO,
  toPersistence,
  fromPersistence,
};
